import { TFunction } from "react-i18next";
import { importDefaultOrderTypes, importOrderDateMatchTypes } from "./constants";

export const getDefaultOrderTypesInputOptions = (t: TFunction) =>
	importDefaultOrderTypes.map((defaultOrderType) => ({
		value: defaultOrderType,
		label: t(`enums.orders.types.${defaultOrderType}`),
	}));

export const getOrderDateMatchTypesInputOptions = (t: TFunction) =>
	importOrderDateMatchTypes.map((orderDateMatchType) => ({
		value: orderDateMatchType,
		label: t(`enums.orders.date_match_types.${orderDateMatchType}`),
	}));
